import { render, staticRenderFns } from "./CargoTypes.vue?vue&type=template&id=4e7252c2&scoped=true"
import script from "./CargoTypes.vue?vue&type=script&lang=js"
export * from "./CargoTypes.vue?vue&type=script&lang=js"
import style0 from "./CargoTypes.vue?vue&type=style&index=0&id=4e7252c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7252c2",
  null
  
)

export default component.exports